import Vue from 'vue'
import Router from 'vue-router'
// import IndexLay from '@/view/Pages/index'
// import SignSuccessIndex from '@/view/Pages/signSuccess'
// import Test from '@/view/Pages/test'

Vue.use(Router)
const IndexLay = r => require.ensure([], () => r(require('@/view/Pages/index')), 'IndexLay')
const SignSuccessIndex = r => require.ensure([], () => r(require('@/view/Pages/signSuccess')), 'SignSuccessIndex')
const Test = r => require.ensure([], () => r(require('@/view/Pages/test')), 'Test')

export default new Router({
    routes: [{
        path: '/',
        component: IndexLay,
    }, {
        path: '/SignSuccessIndex',
        component: SignSuccessIndex,
    }, {
        path: '/Pages/test',
        component: Test,
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js